import React from 'react';
import { useModal } from '@/context/modalContext';
import { useModalBodyScroll } from '@/hooks/useModalBodyScroll';
import SelectCardModal from './SelectCardModal';
import { TermsModal } from './TermsModal';
import AccessPolicyModal from './AccessPolicyModal';
import GuestPolicyModal from './GuestPolicyModal';
import BeforeYouGoConfirmationModal from './BeforeYouGo/BeforeYouGoConfirmationModal';
import { modalTypes } from './constants';

const modalRegistry = {
  [modalTypes.ACCESS_POLICY_MODAL]: AccessPolicyModal,
  [modalTypes.BEFORE_YOU_GO_CONFIRMATION_MODAL]: BeforeYouGoConfirmationModal,
  [modalTypes.GUEST_POLICY_MODAL]: GuestPolicyModal,
  [modalTypes.SELECT_CARD_MODAL]: SelectCardModal,
  [modalTypes.TERMS_MODAL]: TermsModal,
};

const RootModal = () => {
  const { modalName } = useModal();
  const isOpen = !!modalName;
  useModalBodyScroll(isOpen);

  if (!isOpen) {
    return null;
  }

  const ModalComponent = modalRegistry[modalName];

  return <ModalComponent />;
};

export default RootModal;
